import {connect} from 'react-redux';

import DataConnector from 'connect/DataConnector';
import {BenchlingState} from 'redux-stores/reduceApp';
import {getStore} from 'redux-stores/Store';
import * as RequestTaskSchemaDAO from 'requests/schemas/RequestTaskSchemaDAO';
import * as RequestTaskSchemaReduxActions from 'requests/schemas/RequestTaskSchemaReduxActions';
import {RequestTaskSchema} from 'requests/tasks/RequestTaskConstants';
import {
  EnhancedProps,
  SchemaEditSection,
  SchemaPage,
  SchemaPageProps,
} from 'results/assay-schemas/SchemaPage';
import {SchemaSpec} from 'schemas/spec/SchemaConfigConstants';

class RequestTaskSchemaEditConnector extends DataConnector<{schemaId: string}, EnhancedProps> {
  // Ideally could re-use this across schema connectors. Find a better way to re-use code in this class next
  // time a specced model is added
  getEditingName(stateName: string | null, schema: RequestTaskSchema | null): string {
    if (stateName != null) {
      return stateName;
    } else if (schema) {
      return schema.name;
    } else {
      return '';
    }
  }

  enhanceProps(): EnhancedProps {
    const {requestTaskSchemasById} = this.reduxState().models.requests.schemas;
    const schema = requestTaskSchemasById == null ? null : requestTaskSchemasById[this.props.schemaId];
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    const fetchSchema = (schemaId: string) => {
      getStore().dispatch(RequestTaskSchemaReduxActions.fetchSchemaSpec(schemaId));
    };
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    const updateSchema = ({
      schemaId,
      schemaName,
      sqlIdentifier,
      spec,
    }: {
      schemaId: string;
      schemaName: string;
      sqlIdentifier: string | null;
      spec: SchemaSpec;
    }) => {
      getStore().dispatch(RequestTaskSchemaReduxActions.updateSchemaSpec({schemaId, schemaName, spec}));
    };
    const {name, specString, errorState, sessionId} = this.reduxState().ui.schemaConfig;
    const {errors, errorMessage} = errorState != null ? errorState : {errors: null, errorMessage: null};
    return {
      allowEditMetadata: true,
      errors,
      errorMessage,
      name: this.getEditingName(name, schema),
      schema,
      specString,
      fetchSchema,
      updateSchema,
      warehouseTableName: schema && schema.sqlIdentifier,
      ownerName: schema && schema.organization.name,
      sessionId,
    };
  }
}

const RequestTaskSchemaEditSection = RequestTaskSchemaEditConnector.connect(SchemaEditSection);

export default connect((state: BenchlingState, ownProps: SchemaPageProps) => {
  const {requestTaskSchemasById} = state.models.requests.schemas;
  return {
    editSectionClass: RequestTaskSchemaEditSection,
    listingUrl: RequestTaskSchemaDAO.taskSchemaListingURL(),
    schema: requestTaskSchemasById ? requestTaskSchemasById[ownProps.schemaId] : null,
  };
})(SchemaPage);
